<template>

  <CommonPrivateView>
    <template v-slot:header>

      <div class="py-8">
        <div class="w-full flex flex-col items-center justify-center mx-auto" v-if="empresa">
          <img v-if="empresa.previewLogo" :src="empresa.previewLogo" class="w-36 h-36 rounded-full mx-auto" />
          <div v-else class="w-36 h-36 rounded-full mx-auto bg-white" />

          <a @click="isFileUploadVisible = true" v-if="empresa"
            class="cursor-pointer mt-3 py-2 px-4 block rounded-lg border border-white bg-transparent text-white hover:bg-black hover:text-white">
            <font-awesome-icon :icon="['fas', 'upload']" />
            SUBIR LOGO
          </a>
        </div>
      </div>

    </template>
    <template v-slot:content>

      <Form @submit="onSubmit" class="w-full" :validation-schema="schema" @invalid-submit="onInvalidSubmit"
        v-if="empresa">

        <div class="w-full text-gray-600 px-0 mx-auto flex justify-center">
          <div class="w-full space-y-4 pb-5">

            <!-- EMPRESA -->
            <div class="relative w-full shadow-lg rounded-lg bg-white px-4 py-3 pb-5">
              <div class="flex items-center justify-between">
                <div class="font-semibold text-lg">
                  MI EMPRESA
                </div>
                <span v-if="empresa" :class="empresa.activo ? 'bg-green-600' : 'bg-red-600'"
                  class="text-white text-xs font-semibold px-2 py-1 rounded-md h-full flex items-center">
                  {{ empresa.activo ? 'ACTIVA' : 'INACTIVA' }}
                </span>
              </div>

              <div class="w-full text-xs" v-if="empresa">
                Fecha de alta : {{ formatDate(new Date(empresa.fechaAlta), 'dd/MM/yyyy HH:mm:ss') }} | Fecha de
                actualización : {{ formatDate(new Date(empresa.fechaModificacion), 'dd/MM/yyyy HH:mm:ss') }}
              </div>

              <div class=" w-full">
                <div class="flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-3">
                  <div class="w-full px-2 md:w-1/1">
                    <label class="block mb-1">Razón social</label>
                    <Field name="razonSocial" v-slot="{ field, errors }" v-model="empresa.razonSocial">
                      <InputText v-bind="field" type="text" placeholder="Razón social" class="input-base"
                        :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0 }" />
                      <span class="text-sm text-red-500 p-error">
                        <ErrorMessage name="razonSocial" />
                      </span>
                    </Field>
                  </div>
                </div>
                <div class="flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-3">
                  <div class="w-full px-2 md:w-6/12">
                    <label class="block mb-1">País</label>
                    <Field name="pais" v-slot="{ handleChange, handleBlur, value, errors }" v-model="empresa.pais">
                      <Dropdown @blur="handleBlur" filter @update:model-value="handleChange" :model-value="value"
                        placeholder="Seleccioná el país" class="input-base" :options="paises" optionLabel="descripcion"
                        :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && value !== undefined, 'input-error': errors.length > 0 }" />
                      <span class="text-sm text-red-500 p-error">
                        <ErrorMessage name="pais" />
                      </span>
                    </Field>
                  </div>
                  <div class="w-full px-2 md:w-6/12">
                    <label class="block mb-1">Provincia / Estado</label>
                    <Field name="provincia" v-slot="{ field, errors }" v-model="empresa.provincia">
                      <InputText v-bind="field" type="text" placeholder="Provincia / Estado" class="input-base"
                        :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0 }" />
                      <span class="text-sm text-red-500 p-error">
                        <ErrorMessage name="provincia" />
                      </span>
                    </Field>
                  </div>
                </div>
                <div class="flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-3">
                  <div class="w-full px-2 md:w-4/12">
                    <label class="block mb-1">Localidad / Ciudad</label>
                    <Field name="localidad" v-slot="{ field, errors }" v-model="empresa.localidad">
                      <InputText v-bind="field" type="text" placeholder="Localidad / Ciudad" class="input-base"
                        :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0 }" />
                      <span class="text-sm text-red-500 p-error">
                        <ErrorMessage name="localidad" />
                      </span>
                    </Field>
                  </div>
                  <div class="w-full px-2 md:w-2/12">
                    <label class="block mb-1">C.P.</label>
                    <Field name="codigoPostal" v-slot="{ field, errors }" v-model="empresa.codigoPostal">
                      <InputText v-bind="field" type="text" placeholder="Código postal" class="input-base"
                        :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0 }" />
                      <span class="text-sm text-red-500 p-error">
                        <ErrorMessage name="codigoPostal" />
                      </span>
                    </Field>
                  </div>
                  <div class="w-full px-2 md:w-6/12">
                    <label class="block mb-1">Domicilio</label>
                    <Field name="domicilio" v-slot="{ field, errors }" v-model="empresa.domicilio">
                      <InputText v-bind="field" type="text" placeholder="Domicilio" class="input-base"
                        :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0 }" />
                      <span class="text-sm text-red-500 p-error">
                        <ErrorMessage name="domicilio" />
                      </span>
                    </Field>
                  </div>
                </div>
              </div>

            </div>
            <!-- FIN EMPRESA -->

            <!-- DATOS COMERCIALES -->
            <div class="relative w-full shadow-lg rounded-lg bg-white px-4 py-3 pb-5"
              v-if="empresa && empresa.expositor">
              <div class="flex items-center justify-between font-semibold text-lg ">
                DATOS COMERCIALES Y DE CONTACTO
              </div>

              <div class=" w-full">

                <div class="flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-3">
                  <div class="w-full px-2 md:w-8/12">
                    <label class="block mb-1">Nombre de fantasía</label>
                    <Field name="nombreFantasia" v-slot="{ field, errors }" v-model="empresa.nombreFantasia">
                      <InputText v-bind="field" type="text" placeholder="Nombre de fantasía" class="input-base"
                        :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0 }" />
                      <span class="text-sm text-red-500 p-error">
                        <ErrorMessage name="nombreFantasia" />
                      </span>
                    </Field>
                  </div>
                  <div class="w-full px-2 md:w-4/12">
                    <label class="block mb-1">Stand</label>
                    <Field name="stand" v-slot="{ field, errors }" v-model="empresa.stand">
                      <InputText v-bind="field" type="text" placeholder="Stand" class="input-base"
                        :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0 }" />
                      <span class="text-sm text-red-500 p-error">
                        <ErrorMessage name="stand" />
                      </span>
                    </Field>
                  </div>
                </div>
                <div class="flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-3">
                  <div class="w-full px-2 md:w-1/1">
                    <label class="block mb-1">Breve descripción</label>
                    <Field name="breveDescripcion" v-slot="{ field, errors }" v-model="empresa.breveDescripcion">
                      <Textarea rows="4" v-bind="field" type="text" placeholder="Breve descripción de la empresa"
                        class="input-base"
                        :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0 }" />
                      <span class="text-sm text-red-500 p-error">
                        <ErrorMessage name="breveDescripcion" />
                      </span>
                    </Field>
                  </div>
                </div>
                <div class="flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-3">
                  <div class="w-full px-2 md:w-6/12">
                    <label class="block mb-1">Mail comercial</label>
                    <Field name="mailComercial" v-slot="{ field, errors }" v-model="empresa.mailComercial">
                      <InputText v-bind="field" type="mail" placeholder="Mail comercial" class="input-base"
                        :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0 }" />
                      <span class="text-sm text-red-500 p-error">
                        <ErrorMessage name="mailComercial" />
                      </span>
                    </Field>
                  </div>
                  <div class="w-full px-2 md:w-1/2">
                    <label class="block mb-1">Teléfono comercial</label>
                    <Field name="telefono" v-slot="{ field, errors }" v-model="empresa.telefono">
                      <InputText v-bind="field" type="text" placeholder="Teléfono comercial" class="input-base"
                        :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0 }" />
                      <span class="text-sm text-red-500 p-error">
                        <ErrorMessage name="telefono" />
                      </span>
                    </Field>
                  </div>
                </div>
                <div v-if="empresa">
                  <div v-for="empresaRedSocial in empresa.empresaRedesSociales" v-bind:key="empresaRedSocial.id"
                    :empresaRedSocial="empresaRedSocial">
                    <div class="flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-3">
                      <div class="w-full px-2">
                        <InputGroup>
                          <InputGroupAddon><font-awesome-icon class="text-black"
                              :icon="empresaRedSocial.redSocial.icono.split(' ')" /></InputGroupAddon>
                          <Field :name="`link-${empresaRedSocial.id}`" v-slot="{ field, errors }"
                            v-model="empresaRedSocial.link">
                            <InputText v-model="empresaRedSocial.link"
                              :placeholder="empresaRedSocial.redSocial.descripcion" class="input-group-base"
                              :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0 }" />
                          </Field>
                        </InputGroup>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>


            <!-- FIN DATOS COMERCIALES -->

            <!-- CATEGORÍAS -->
            <div class="relative w-full shadow-lg rounded-lg bg-white px-4 py-3 pb-5"
              v-if="empresa && empresa.expositor">
              <div class="flex items-center justify-between font-semibold text-lg ">
                CATEGORÍAS
              </div>

              <div class="w-full">
                <div v-if="tags">
                  <div v-for="tag in tags" v-bind:key="tag.id" :tag="tag">
                    <div class="flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-3">
                      <div class="w-full px-2">
                        <label class="block mb-1">{{ tag.descripcion }}</label>
                        <Field :name="`tag-${tag.id}`" v-slot="{ errors }">
                          <MultiSelect :model-value="tag.opcionesTagSeleccionados"
                            @update:model-value="val => tag.opcionesTagSeleccionados = val" :options="tag.opciones"
                            optionLabel="descripcion" optionValue="id" filter :placeholder="tag.descripcion"
                            class="input-base"
                            :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && tag.opcionesTagSeleccionados?.length > 0, 'input-error': errors.length > 0 }" />
                        </Field>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- FIN CATEGORÍAS -->

            <!-- BOTONES -->
            <div class="relative w-full shadow-lg rounded-lg bg-white px-4 py-3">
              <div class="container w-full">
                <div class="flex flex-wrap gap-2">
                  <button type="submit"
                    class="px-4 py-2 bg-transparent border-black hover:bg-black text-black font-semibold hover:text-white border rounded"
                    :disabled="isSubmitting">
                    <i v-show="isSubmitting" class="pi pi-spin pi-spinner mr-2"></i>
                    <i v-show="!isSubmitting" class="pi pi-check mr-2"></i>ACEPTAR
                  </button>
                  <button type="button" @click="cancelarModificacion"
                    class="px-4 py-2 bg-transparent border-red-700 hover:bg-red-700 text-red-700 font-semibold hover:text-white border rounded"
                    :disabled="isSubmitting">
                    <i class="pi pi-times mr-2"></i>CANCELAR
                  </button>
                </div>
              </div>
            </div>
            <!-- FIN BOTONES -->

          </div>
        </div>

      </Form>

    </template>
  </CommonPrivateView>

  <BlockUI :blocked="isSubmitting" fullScreen />

  <ModalFileUpload :visible="isFileUploadVisible" :askDescription="false" :forceSquare="false" :maxSizeMB="2"
    :fileTypes="['image/png', 'image/jpg', 'image/jpeg']" :onAccept="onFileUploadAcepted"
    @update:visible="isFileUploadVisible = $event" />

  <CropperView v-if="showCropper" :image="beforeCropBase64" @close="onCropFinished" />

</template>

<script lang="ts">
import * as yup from 'yup';

import { defineComponent } from 'vue';
import { Field, Form, ErrorMessage } from 'vee-validate';
import Swal from 'sweetalert2'

import BlockUI from 'primevue/blockui';
import InputText from 'primevue/inputtext';
import Dropdown from 'primevue/dropdown';
import Textarea from 'primevue/textarea';
import InputGroup from 'primevue/inputgroup';
import InputGroupAddon from 'primevue/inputgroupaddon';
import MultiSelect from 'primevue/multiselect';

import ModalFileUpload from "@/components/commons/ModalFileUpload.vue";
import CommonPrivateView from '@/components/commons/CommonPrivateView.vue';

import suiteConfig from '@/services/suite.config';
import empresaService, { Empresa, UsuarioEmpresa } from 'qreventos-suite/empresas';
import generalService from 'qreventos-suite/generales';
import seguridadServices from '@/services/seguridad.services';
import { EmpresaTag, Pais, Tag, TagOpcion } from 'qreventos-suite/src/services/suite.interfaces';
import { TAG_TIPO_EMPRESA } from "qreventos-suite/constantes";
import { formatDate } from 'date-fns';

import CropperView from '@/components/commons/CropperView.vue'

export default defineComponent({
  components: {
    InputText, Dropdown, BlockUI, Textarea, MultiSelect,
    InputGroup, InputGroupAddon,
    Form, ErrorMessage, Field,
    ModalFileUpload, CommonPrivateView,
    CropperView
  },
  created() {
    document.title = "Empresas";
    suiteConfig.token = "bUJldXJDYnNJRVdFdVVCL3FnbmI4UGtXZ05VMWYzclVtbXdBYU1sclNFWT0=";
  },
  data() {
    return {
      paises: [] as Pais[],
      isSubmitting: false,
      empresa: undefined as unknown as Empresa,
      tags: [] as Tag[],
      usuarioEmpresa: seguridadServices.getLocalUsuarioEmpresa() as UsuarioEmpresa,
      isFileUploadVisible: false,


      beforeCropBase64: '',
      showCropper: false,


    };
  },
  computed: {
    schema() {
      return yup.object({
        razonSocial: yup.string().required('Ingresá la razón social').min(3, 'Al menos 3 letras'),

        domicilio: yup.string().required('Ingresá el domicilio').min(5, 'Al menos 5 letras'),
        localidad: yup.string().required('Ingresá la localidad').min(4, 'Al menos 4 letras'),
        provincia: yup.string().required('Ingresá la provincia').min(4, 'Al menos 4 letras'),
        pais: yup.mixed().required('Seleccioná el país de la empresa'),
        codigoPostal: yup.string().required('Ingresá el C.P.').min(4, 'Al menos 4 letras'),

        nombreFantasia: this.empresa.expositor
          ? yup.string().required('Ingresá el nombre de fantasía').min(3, 'Al menos 3 letras')
          : yup.string().notRequired(),

        breveDescripcion: this.empresa.expositor
          ? yup.string().required('Ingresá una breve descripción de la empresa').min(50, 'Al menos 50 letras')
          : yup.string().notRequired(),

        telefono: this.empresa.expositor
          ? yup.string().required('Ingresá el teléfono comercial').matches(/^\d+$/, 'Solo se permiten números').min(7, 'Al menos 7 números')
          : yup.string().notRequired(),

        mailComercial: this.empresa.expositor
          ? yup.string().required('Ingresá el mail comercial').email('Correo inválido')
          : yup.string().notRequired(),
      });
    }
  },
  methods: {
    formatDate,
    async onFileUploadAcepted(base64: string, fileName: string) {
      const base64Splited: string = base64.split(',')[1];

      this.empresa.logoFileName = new Date().getTime() + "_" + fileName.replace(/[^a-zA-Z0-9.]/g, '');
      this.empresa.logoBase64 = base64Splited;
      this.beforeCropBase64 = base64;
      //this.empresa.previewLogo = base64;

      this.showCropper = true;
    },
    async onCropFinished(croppedBase64: string) {
      this.showCropper = false
      if (!croppedBase64) return

      const base64Splited = croppedBase64.split(',')[1]
      this.empresa.logoBase64 = base64Splited
      this.empresa.previewLogo = croppedBase64

      await empresaService.saveOrUpdate(this.usuarioEmpresa.evento.id, this.empresa)
    },
    cancelarModificacion() {
      Swal.fire({ title: "¡Atención!", text: 'La modificación fue cancelada', icon: "info" }).then(() => {
        this.fillEmpresa();
      });
    },
    async fillEmpresa() {
      this.isSubmitting = true;

      try {
        this.usuarioEmpresa = await seguridadServices.getLocalUsuarioEmpresa() as UsuarioEmpresa;
        this.empresa = await empresaService.findEmpresaBy(this.usuarioEmpresa.evento.id, this.usuarioEmpresa.empresa.id) as Empresa;

        if (this.empresa) {
          if (this.empresa.pais) {
            this.empresa.pais = this.paises.find(pais => pais.id === this.empresa.pais.id) as Pais;
          }
          if (this.empresa.expositor) {
            this.tags = await empresaService.findTagsBy(this.usuarioEmpresa.evento.id, TAG_TIPO_EMPRESA);
            if (this.tags.length > 0) {
              for (let i: number = 0; i < this.tags.length; i++) {
                const tag: Tag = this.tags[i];
                tag.opcionesTagSeleccionados = this.empresa.empresaTags.filter(empresaTag => empresaTag.tag.id === tag.id).map(empresaTag => empresaTag.tagOpcion.id);
              }
            }
          }
        }

      } catch (error) {
        this.isSubmitting = false;
        Swal.fire({ title: "Error", text: error + '', icon: "error" });
      } finally {
        this.isSubmitting = false;
      }
    },
    onInvalidSubmit(values: any) {
      const errores: number = Object.values(values?.errors || {}).flat().length;
      Swal.fire({ title: "Error", html: "Por favor revisá el formulario<br/>Se encontraror " + errores + " campos con error.", icon: "error" });
    },
    async onSubmit() {
      this.isSubmitting = true;

      try {
        if (this.empresa.expositor) {
          this.empresa.empresaTags = [] as EmpresaTag[];
          this.tags.forEach(tag => {
            tag.opcionesTagSeleccionados.forEach(tagOpcionSeleccionada => {
              const empresaTag: EmpresaTag = {} as EmpresaTag;
              empresaTag.tag = tag;
              empresaTag.tagOpcion = { "id": tagOpcionSeleccionada } as TagOpcion;
              this.empresa.empresaTags.push(empresaTag);
            })
          });
        }

        await empresaService.saveOrUpdate(this.usuarioEmpresa.evento.id, this.empresa);

        Swal.fire({
          title: "¡Atención!",
          html: "Su transacción se realizó con éxito.",
          icon: "success",
        }).then(() => {
          this.fillEmpresa();
        });

      } catch (error) {
        this.isSubmitting = false;
        Swal.fire({ title: "Error", text: error + '', icon: "error" });
      } finally {
        this.isSubmitting = false;
      }
    }
  },
  async mounted() {
    try {

      this.paises = await generalService.findPaisesBy();

      this.fillEmpresa();
    }
    catch (error) {
      Swal.fire({ title: "Error", text: 'Sesión expirada [' + error + ']', icon: "error" })
        .then(() => {
          seguridadServices.logout();
          this.$router.push({ path: '/' });
        });
    }
  }
});
</script>
